import { Head } from "@inertiajs/react";
import { ConnectDocuments, ConnectNotificationBanner } from "@stripe/react-connect-js";
import { t } from "@travily/i18n";
import {
  accountPayoutsConnectSessionPath,
  accountPayoutsDocumentsPath,
  accountPayoutsManagePath,
  accountPayoutsPath,
  accountPayoutsSalesPath,
} from "@travily/routes";
import { useStripeConnectSessionRefresher } from "@/hooks/use-stripe-connect-session-refresher";
import { PageFrame } from "@/layouts/page-frame";
import type { PayoutsTab } from "@/pages/account/payouts/components/PayoutsFrame";
import { AccountPayoutsDocumentsView } from "./documents.view";

interface AccountPayoutsDocumentsProps {
  client_secret: string;
  publishable_key: string;
}

const AccountPayoutsDocumentsPage = ({ client_secret, publishable_key }: AccountPayoutsDocumentsProps) => {
  const fetchRefreshedClientSecret = useStripeConnectSessionRefresher(accountPayoutsConnectSessionPath());
  const tabs = useTabs();

  return (
    <PageFrame mode="creator">
      <Head title={t("web.accounts.payouts.show.meta_title")} />
      <AccountPayoutsDocumentsView
        fetchRefreshedClientSecret={fetchRefreshedClientSecret}
        initialClientSecret={client_secret}
        publishableKey={publishable_key}
        tabs={tabs}
      >
        <ConnectNotificationBanner />
        <ConnectDocuments />
      </AccountPayoutsDocumentsView>
    </PageFrame>
  );
};

function useTabs(): PayoutsTab[] {
  return [
    { key: "overview", label: t("components.frames.payouts.tabs.overview"), href: accountPayoutsPath() },
    { key: "sales", label: t("components.frames.payouts.tabs.sales"), href: accountPayoutsSalesPath() },
    { key: "manage", label: t("components.frames.payouts.tabs.manage"), href: accountPayoutsManagePath() },
    { key: "documents", label: t("components.frames.payouts.tabs.documents"), href: accountPayoutsDocumentsPath() },
  ];
}

export default AccountPayoutsDocumentsPage;
